import React from 'react';
import { capitalize } from '@crazyegginc/hatch';

import { AppConfig } from '../../AppConfig';
import { getSessionQueryParameters } from '/src/utils/url';
import { DateDisplay } from '/src/components/date-time/DateDisplay';
import { IconWithTooltip } from './IconWithTooltip';
import { AppLink } from '/src/features/_global/components/AppLink';

export function RenderInfos({ infos, consoleErrors = null, originalUrl, finalUrl, ui = {} }) {
  const itemClassName = ui.statusItemClassName ?? 'text-body-2 relative min-h-[30px] py-1';
  const strongClassName = ui.strongClassName ?? 'text-body-1';

  if ((!consoleErrors || consoleErrors.length === 0) && (!infos || infos.length === 0)) {
    return null;
  }

  return (
    <>
      <div className={ui.spacerClassName ?? 'h-[30px]'} />
      {infos &&
        infos
          .filter((info) => info.name === 'PAGE_REDIRECTS')
          .map((info, i) => (
            <div className={itemClassName} key={`PageRedirects-${i}`}>
              <IconWithTooltip
                type="info"
                className={ui.iconBackgroundClassName}
                iconClassName={ui.statusIconClassName}
                containerClassName={ui.statusIconContainerClassName}
              />
              <div>
                <strong className={strongClassName}>Page Redirect Detected -</strong>&nbsp;The webpage redirected to{' '}
                <strong className={strongClassName}>{info.redirect}</strong>, so the install check was run on{' '}
                <strong className={strongClassName}>{info.redirect}</strong>. This might be because{' '}
                <strong className={strongClassName}>{originalUrl}</strong> is behind a login.
              </div>
            </div>
          ))}
      {infos &&
        infos
          .filter((info) => info.name === 'HAS_SCHEDULED_SNAPSHOT')
          .map((info, i) => (
            <div className={itemClassName} key={`HasScheduledSnapshot-${i}`}>
              <IconWithTooltip
                type="info"
                className={ui.iconBackgroundClassName}
                iconClassName={ui.statusIconClassName}
                containerClassName={ui.statusIconContainerClassName}
              />
              <div>
                <strong className={strongClassName}>Heatmaps -</strong>&nbsp;This page has a Heatmap scheduled to start{' '}
                on <DateDisplay className="text-body-1 font-semibold" date={info.startsAt} />.
              </div>
            </div>
          ))}
      {infos && infos.find((info) => info.name === 'NO_RUNNING_SNAPSHOTS') && (
        <div className={itemClassName}>
          <IconWithTooltip
            type="info"
            className={ui.iconBackgroundClassName}
            iconClassName={ui.statusIconClassName}
            containerClassName={ui.statusIconContainerClassName}
          />
          <div>
            <strong className={strongClassName}>Heatmaps -</strong>&nbsp;There are currently no Heatmaps running on{' '}
            <strong className={strongClassName}>{finalUrl}</strong>
          </div>
        </div>
      )}
      {infos &&
        infos
          .filter((info) => info.name === 'RECORDINGS_DISABLED')
          .map((info, i) => (
            <div className={itemClassName} key={`RecordingsDisabled-${i}`}>
              <IconWithTooltip
                type="info"
                className={ui.iconBackgroundClassName}
                iconClassName={ui.statusIconClassName}
                containerClassName={ui.statusIconContainerClassName}
              />
              <div>
                <strong className={strongClassName}>Recordings -</strong>&nbsp;This URL is currently not set under page
                targeting or the site needs to be enabled.{' '}
                <AppLink target="_blank" rel="noopener noreferrer" className="text-link" to={`/options/site-settings`}>
                  Click here
                </AppLink>{' '}
                to adjust the settings.
              </div>
            </div>
          ))}
      {infos &&
        infos
          .filter((info) => info.name === 'DATA_BEING_TRACKED_TO')
          .map((info, i) => (
            <div className={itemClassName} key={`DataBeingTrackedTo-${i}`}>
              <IconWithTooltip
                type="info"
                className={ui.iconBackgroundClassName}
                iconClassName={ui.statusIconClassName}
                containerClassName={ui.statusIconContainerClassName}
              />
              <div>
                <strong className={strongClassName}>Heatmaps -</strong>&nbsp;Data from{' '}
                <strong className={strongClassName}>{finalUrl}</strong> is currently being tracked to{' '}
                {info.snapshotHasData ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-link"
                    href={`${AppConfig.legacyCoreBaseURL()}/snapshots/${
                      info.snapshotId
                    }?${getSessionQueryParameters()}`}
                  >
                    {info.snapshotName}
                  </a>
                ) : (
                  <AppLink target="_blank" rel="noopener noreferrer" className="text-link" to="/snapshots">
                    {info.snapshotName}
                  </AppLink>
                )}{' '}
                on {capitalize(info.snapshotDevice.toLowerCase())}
              </div>
            </div>
          ))}
    </>
  );
}
